/**
 * @author Tan_ruilong
 * @date 2021/8/11 10:13
 * @创建自建应用
 */
import React from 'react'
import first_img from "../../../../images/config/authorizationProgress/1.png"
import second_img from "../../../../images/config/authorizationProgress/2.png"
import CorpApi from "../../../public/corp_api";
class AuthorizationEstablish extends React.Component {
    constructor(props){
        super(props)
        this.state={
            logo:'',
        }
    }
    componentDidMount() {
        // CorpApi
    }

    render() {
        return (
            <div className={'authorizationEstablish'}>
                <div>
                    <div>（1）登录企业微信后台<a href='https://work.weixin.qq.com/wework_admin/frame#apps' target="_blank">https://work.weixin.qq.com/wework_admin/frame#apps</a></div>
                    <div>（2）操作路径：企业微信管理后台—应用管理—自建—创建应用</div>
                    <div><img src={first_img}/></div>
                    <div>（3） 创建自建应用名称建议填写「紫鲲」，<a href='/zksc/corp/auth/logo/download'  download="Logo.png">点击这里</a>下载应用logo进行上传，不用填写应用介绍</div>
                    <div>（4）在【可见范围】内【选择部门/成员】，可先选择授权给本人，之后若需要添加使用人员时可再次添加</div>
                    <div><img src={second_img}/></div>
                </div>
            </div>
        )
    }
}

export default AuthorizationEstablish
